export enum PropertyType {
  Unknown = 0,
  String = 1,
  Number = 2,
  Boolean = 3,
  Enum = 4,
  List = 5
}
